import { combineReducers } from "@reduxjs/toolkit";
import searchTableReducer from "./searchTable";
import academicRecognitionTabReducer from "./academicRecognitionData";

const searchDataReducers = combineReducers({
  searchTable: searchTableReducer,
  academicRecognitionTab: academicRecognitionTabReducer,
});

export default searchDataReducers;
